export default "__VITE_ASSET__xOFOyk9A__"